export default __webpack_public_path__ + "static/media/performForObjects1.5a59a1fc.png";